var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
let ElementLineCheckbox = class ElementLineCheckbox extends LitElement {
    constructor() {
        super(...arguments);
        this.bodyLinksTextFont = true;
        this.checked = false;
        this.name = '';
        this.checkboxFirst = false;
        this.sign = false;
    }
    render() {
        return html ` <label
      data-cy="${this.name}"
      tabindex="0"
      class="${classMap({
            'text-focused-red': this.checked,
            'flex-row-reverse': this.checkboxFirst,
            'justify-end': this.checkboxFirst,
            'justify-between': !this.checkboxFirst,
            'hover:bg-page-main': !this.sign,
            'px-[12px]': !this.sign,
            'py-[9px]': !this.sign,
            'body-links-and-text': this.bodyLinksTextFont,
            body: !this.bodyLinksTextFont,
        })} relative flex cursor-pointer
          select-none"
      >${this.label()}<input
        tabindex="-1"
        class="${classMap({
            sign: this.sign,
            'mr-[12px]': this.checkboxFirst,
        })} w-0 opacity-0"
        type="checkbox"
        name=${this.name}
        .checked=${this.checked}
      /><span
        class="${classMap({
            'lg:mt-[8px]': !this.bodyLinksTextFont,
        })} mt-[2px] md:mt-[5px]"
      ></span>
    </label>`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Boolean })
], ElementLineCheckbox.prototype, "bodyLinksTextFont", void 0);
__decorate([
    property({ type: Boolean })
], ElementLineCheckbox.prototype, "checked", void 0);
__decorate([
    property({ type: String })
], ElementLineCheckbox.prototype, "name", void 0);
__decorate([
    property({ type: Object })
], ElementLineCheckbox.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], ElementLineCheckbox.prototype, "checkboxFirst", void 0);
__decorate([
    property({ type: Boolean })
], ElementLineCheckbox.prototype, "sign", void 0);
ElementLineCheckbox = __decorate([
    customElement('element-line-checkbox')
], ElementLineCheckbox);
export { ElementLineCheckbox };
//# sourceMappingURL=element-line-checkbox.js.map